pageId = 'page-member-settings_change_dingtalk'
page = '#' + pageId

$ ->
  $(document).on 'ajax:success', "#{ page } .form-settings-change-dingtalk", (e, result) ->
    if result.success
      simple.dialog.message content: result.msg
      setTimeout ->
        if result.need_signin
          location.href = result.url
        else
          tower.stack.load result.url,
            root: true
      , 2000
